export * from './Internet'



// WEBPACK FOOTER //
// src/pages/Internet/index.ts